import { apiAService } from "../apiService";
import urlConfig from "../../../config/domain";
import { jwtToken } from "../../types/genericTypes";
import LoginService,{getinvAccDet} from "../login/loginService";
import { config } from "../../../config/domain";

let pToken: jwtToken | null = LoginService.pToken,
  userID = pToken ? pToken.username : null;
  let invOnlyAcc = getinvAccDet();

//after redirect reinstate pToken with parsed jwt token
const pTokenCheck = (paramChk?: keyof jwtToken) => {
  if (!pToken) {
    pToken = LoginService.pToken;
    userID = pToken ? pToken.username : null;
  }
  return paramChk && pToken ? pToken[paramChk] : pToken;
};
export const ValidateOtp = async (payload: any) => {
  return await apiAService({
    url: urlConfig.account.VerifyOtp,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const GetFamilyRelationshipList = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.FamilyRelationshipList:urlConfig.profile.FamilyRelationshipList,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const GetFamilyRelatDropList = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.FamilyDeclarationList:urlConfig.profile.FamilyDeclarationList,
    method: "GET",
    authType: "bearer",
  });
};
export const SendOtp = async (payload: any) => {
  return await apiAService({
    url: urlConfig.account.GenerateOtp,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const getDPID = async () => {
  return await apiAService({
    url: urlConfig.profile.getDPID,
    method: "GET",
    authType: "bearer",
  });
};
export const checkValidation = async (payload: any) => {
  return await apiAService({
    url: urlConfig.profile.checkValidation,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const CreateServiceRequestDetails = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.CreateServiceRequest:urlConfig.profile.CreateServiceRequest,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};

export const GetDepositoryDetails = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.DepositoryDetail:urlConfig.profile.DepositoryDetail,
    method: "GET",
    authType: "bearer",
  });
};
export const GetExistingIncomeRange = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.ExistingIncomeRange:urlConfig.profile.ExistingIncomeRange,
    method: "GET",
    authType: "bearer",
  });
};
export const GetNewIncomeRange = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.NewIncomeRange:urlConfig.profile.NewIncomeRange,
    method: "GET",
    authType: "bearer",
  });
};
export const CreateServiceRequest = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.CreateServiceRequest:urlConfig.profile.CreateServiceRequest,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const ServiceClientValidation = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.ServiceClientValidation:urlConfig.profile.ServiceClientValidation,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const SendWhatsappConsent = async (payload: any) => {
  return await apiAService({
    url: config.whatsapp_consent,
    method: "POST",
    authType: "mwAuth",
    body: payload,
  });
};
export const ServiceSchemeValidation = async (payload: any) => {
  return await apiAService({
    url: urlConfig.profile.ServiceSchemeValidation,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const GetPersonDetails = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.personalDetails:urlConfig.profile.personalDetails,
    method: "GET",
    authType: "bearer",
  });
};
export const GetbankDetails = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.bankDetails:urlConfig.profile.bankDetails,
    method: "GET",
    authType: "bearer",
  });
};
export const GetPOAFlagDetails = async () => {
  return await apiAService({
    url: urlConfig.profile.POAFlagDetails,
    method: "GET",
    authType: "bearer",
  });
};

export const GetValidateDetailsSegment = async () => {
  return await apiAService({
    url: urlConfig.profile.POAFlagDetails,
    method: "GET",
    authType: "bearer",
  });
};
export const GetCKYCValidation = async () => {
  return await apiAService({
    url: urlConfig.profile.GetCKYCValidation,
    method: "GET",
    authType: "bearer",
  });
};

export const GetAdharVerify = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.adharVerify:urlConfig.profile.adharVerify,
    method: "GET",
    authType: "bearer",
  });
};
export const fatcavalidation = async () => {
  return await apiAService({
    url: urlConfig.profile.FatcaValidation,
    method: "GET",
    authType: "bearer",
  });
};
export const getServicingDetails = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.ServicingDetails:urlConfig.profile.ServicingDetails,
    method: "GET",
    authType: "bearer",
  });
};
export const getPOADownload = async () => {
  return await apiAService({
    url: urlConfig.profile.POADownloadDetails,
    method: "GET",
    authType: "bearer",
  });
};
export const getDematAcctValidation = async (param: any) => {
  return await apiAService({
    url: urlConfig.profile.DematAcctValidation + param,
    method: "GET",
    authType: "bearer",
  });
};

export const GetPreFilledFormPDF = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.GetPreFilledFormPDF:urlConfig.profile.GetPreFilledFormPDF,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};

export const GetEsignUrl = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.GetEsignUrlV2:urlConfig.profile.GetEsignUrlV2,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const GetEsignStatus = async (refId: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.GetEsignStatus + "/" + refId:urlConfig.profile.GetEsignStatus + "/" + refId,
    method: "GET",
    authType: "bearer",
  });
};
export const DownloadEsignDocument = async (appId: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.DownloadEsignDocumentV2 + "/" + appId:urlConfig.profile.DownloadEsignDocumentV2 + "/" + appId,
    method: "GET",
    authType: "bearer",
    // body: payload,
  });
};
export const GetEquityReactivationClientValidation = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.GetEquityReactivationClientValidation:urlConfig.profile.GetEquityReactivationClientValidation,
    method: "GET",
    authType: "bearer",
  });
};

export const CreateChildServiceRequestDetails = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.CreateChildServiceRequestDetails:urlConfig.profile.CreateChildServiceRequestDetails,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};

export const GetAllNewExistingSRDetails = async (id: Number) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.GetAllNewExistingSRDetails + `/${id}`:urlConfig.profile.GetAllNewExistingSRDetails + `/${id}`,
    method: "GET",
    authType: "bearer",
  });
};
export const getRmDetails = async (payload: any) => {
  return await apiAService({
    url: urlConfig.rmDetails + payload,
    method: "GET",
    authType: "bearer",
  });
};
export const getMergeDocumentBase64 = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.getMergeDocument:urlConfig.profile.getMergeDocument,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const getSelectedDocumentDetails = async (payload: any) => {
  return await apiAService({
    url: urlConfig.profile.getSelectedDocument,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const getPaymentBankDetails = async (payload: any) => {
  return await apiAService({
    url: urlConfig.fund.getBankDetails + payload,
    method: "GET",
    authType: "authtoken",
  });
};
export const paymentGateway = async (payload: any) => {
  let accCode = payload.accCode;
  delete payload.accCode;
  return await apiAService({
    url: urlConfig.fund.paymentGateway + accCode,
    method: "POST",
    authType: "authtoken",
    body: payload,
  });
};
export const createSRDocumentUpload = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.createSRDocumentUpload:urlConfig.profile.createSRDocumentUpload,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const fetchDigiLockerUrl = async (payload: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.fetchDigiLockerUrl:urlConfig.profile.fetchDigiLockerUrl,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const getMemorandumDetails = async () => {
  return await apiAService({
    url: urlConfig.profile.getMemorandumDetails,
    method: "GET",
    authType: "bearer",
  });
};
export const createAccReq = async (payload: any) => {
  return await apiAService({
    url: urlConfig.profile.createChildSR,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};
export const updateAccReactStatus = async (payload: any) => {
  return await apiAService({
    url: urlConfig.profile.updatAccReactStatus,
    method: "POST",
    authType: "bearer",
    body: payload,
  });
};

export const getDefaultBankValidationDetails = async (queryParams: any) => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.getDefaultBankValidationDetails + queryParams:urlConfig.profile.getDefaultBankValidationDetails + queryParams,
    method: "GET",
    authType: "bearer",
  });
};

export const getEquityDormantClientCategoryValidation = async () => {
  return await apiAService({
    url: invOnlyAcc?urlConfig.BadlvProfile.GetEquityDormantClientCategoryValidation:urlConfig.profile.GetEquityDormantClientCategoryValidation,
    method: "GET",
    authType: "bearer",
  });
};

export const GetNomineeDetails = async () => {
  if (invOnlyAcc) {
    return await apiAService({
      url: urlConfig.BadlvProfile.getnomineedetails,
      method: "GET",
      authType: "bearer",
    });

  }
  else {
    return await apiAService({
      url: urlConfig.getNomineeDetails + `?accTyp=${pTokenCheck("accType")}`,
      method: "GET",
      authType: "authtoken",
      appidkey: urlConfig.appidkey,
      source: sessionStorage.getItem("source") || undefined,
    });
  }
};
export const createServiceReqNomin = async (payload: any) => {
  return await apiAService({
    url: urlConfig.createServiceReqNomin,
    method: "POST",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const downloadPrefilledNominatinForm = async (srId: string) => {
  return await apiAService({
    url: urlConfig.downloadPrefilledNominatinForm + srId,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
  });
};
export const getClientDet = async (param: "All" | "P" | "D" | "B",
accType: "EQ" | "CO") => {
  return await apiAService({
    url: urlConfig.profile.clientDetails +  accType + "/" + param,
    method: "GET",
    authType: "bearer"
  });
};
export const GetDpDetails = async () => {
  return await apiAService({
    url: urlConfig.sr.getDpDetails + `?accTyp=${pTokenCheck("accType")}`,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const accClosureValidate = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.accClosureValidate,
    method: "POST",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const otpSend = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.otpSend,
    method: "POST",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const otpValidate = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.otpValidate,
    method: "POST",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const accClosureSR = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.accClosureSR,
    method: "POST",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const esignUrlJMW = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.esignUrlJMW,
    method: "POST",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};
export const getEsignStatusJMW = async (refId: any) => {
  return await apiAService({
    url: urlConfig.sr.esignStatusJMW + "?id=" + refId,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};
export const esignDownloadJMW = async (id: string) => {
  return await apiAService({
    url: urlConfig.sr.esignDownloadJMW + `?id=` + id,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const checkExistingSr = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.getServiceDet,
    method: "POST",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const getDdpiDetails = async () => {
  return await apiAService({
    url: urlConfig.sr.getDdpiDetails + `?accTyp=${pTokenCheck("accType")}`,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const DdpiValidation = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.getDdpiValidation,
    method: "POST",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    body: payload,
  });
};

export const createDdpiSR = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.createDdpiSR,
    method: "POST",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    body: payload,
  });
};

export const getDDPIPreFilledFormPDF = async () => {
  return await apiAService({
    url:
      urlConfig.sr.ddpiPreFilledFormPDF + `?accTyp=${pTokenCheck("accType")}`,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const smtfValidation = async () => {
  return await apiAService({
    url: urlConfig.sr.getSMTFValidation + `?accTyp=${pTokenCheck("accType")}`,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};

export const createSMTFSR = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.createSMTFSR,
    method: "POST",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    body: payload,
  });
};

export const createSegmentDeactivationSR = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.createSegmentDeactivation,
    method: "POST",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    body: payload,
  });
};

export const validateSegmentDeactivation = async () => {
  return await apiAService({
    url: urlConfig.sr.validateSegDeactivation + `?accTyp=${pTokenCheck("accType")}`,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};

export const EqPositions = async () => {
  return await apiAService({
    url: urlConfig.position.eq2 + userID,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};
export const EqPositionsNew = async () => {
  return await apiAService({
    url: urlConfig.position.eq2 + userID + `?rTyp=EQFNO`,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};

export const CommPositions = async () => {
  return await apiAService({
    url: urlConfig.position.commodity + userID,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};

export const EqOrderbook = async () => {
  return await apiAService({
    url: urlConfig.orderBook.eq + userID + "/v1",
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};

export const CommOrderbook = async () => {
  return await apiAService({
    url: urlConfig.orderBook.commodity + userID + "?rTyp=COMFNO",
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};
export const CommOrderbookNew = async () => {
  return await apiAService({
    url: urlConfig.orderBook.eq + userID + "?rTyp=COFNO",
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};

export const MfSipOrderbook = async () => {
  return await apiAService({
    url: urlConfig.orderBook.mfSip + userID,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};

export const MfOrderbook = async () => {
  return await apiAService({
    url: urlConfig.orderBook.mf + userID,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};

export const GetBrokerageSlabDetails = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.BrokerageSlabDetails,
    method: "POST",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey
  });
};
export const GetSegmentsDetails = async () => {
  return await apiAService({
    url: urlConfig.sr.getSegmentsDetails + `?accTyp=${pTokenCheck("accType")}`,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};
export const GetSegActivationValidation = async () => {
  return await apiAService({
    url: urlConfig.sr.validateSegActivation + `?accTyp=${pTokenCheck("accType")}`,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey
  });
};
export const createSegmentActivationSR = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.createSegmentActivation,
    method: "POST",
    authType: "authtoken",
    body: payload,
    appidkey: urlConfig.appidkey
  });
};
export const earlyPayInSubmit = async (payload: any) => {
  return await apiAService({
    url: urlConfig.sr.earlyPayInSubmit,
    method: "POST",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    body: payload,
  });
};
export const earlyPayInValidate = async () => {
  return await apiAService({
    url: urlConfig.sr.earlyPayInValidate,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
  });
};
export const getloginDataforApp = async () => {
  return await apiAService({
    url: urlConfig.getloginDataforApp,
    method: "GET",
    authType: "authtoken",
    appidkey: urlConfig.appidkey,
    source: sessionStorage.getItem("source") || undefined,
  });
};